export default "__VITE_ASSET__aWOiJhGQ__"